import { useLocalStorage } from '@vueuse/core'

const redirectUrl = useLocalStorage('redirectUrl', '')
export { redirectUrl }

export function toExternalLink(externalLink: string) {
  window.location.href = externalLink
}
